// extracted by mini-css-extract-plugin
export var orderSummary = "_ts-0";
export var showMoreLessButton = "_ts-1";